import { render, staticRenderFns } from "./Triangles.vue?vue&type=template&id=5c67d04e"
import script from "./Triangles.vue?vue&type=script&lang=js"
export * from "./Triangles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports